//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mfg.AM.js";
import "../no/Builder.js";
import "../Mfg/Mfg.AM.SelectPartList.js";
import "../no/Mfg.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Accuracy",1,0],[0,"BottomDistance",1,0],[0,"ConstraintType",1,0],[0,"InterlockingType",1,0],[0,"NestingType",1,0],[1,"PartsToNest",0,"Mfg.AM.SelectPartList",0],[0,"RotationAngle",1,0],[0,"SolutionType",1,0],[0,"Spacing",1,0],[0,"StartFromEmptyBuildtray",1,0],[0,"StopAfter",1,0],[0,"TargetDensity",1,0],[0,"ViewProgress",1,0],[0,"WallDistance",1,0]],[[[],"ExecuteNesting",{R_:{nestStatus:"Mfg.AM.NestingStatus"}},0,0],[["dLength","dWidth","dHeight"],"SetnestingBox",{},3,0],[["dDiameter","dHeight"],"SetnestingCylinder",{},2,0]],[]];
SPLM.Mfg.AM.Nester3D = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mfg.AM.Nester3D";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mfg.AM.Nester3D.NesterType = Object.freeze({
    "TwoD" : "TwoD", "ThreeD" : "ThreeD"});

SPLM.Mfg.AM.Nester3D.Constraint = Object.freeze({
    "Free" : "Free", "FixedZDirection" : "FixedZDirection", "FixedFloorPlane" : "FixedFloorPlane", "Rotate180" : "Rotate180", "FixedBottomAndXY" : "FixedBottomAndXY", "FixedRotation" : "FixedRotation", "Fixed" : "Fixed"});

SPLM.Mfg.AM.Nester3D.Solution = Object.freeze({
    "OptimizeHeight" : "OptimizeHeight", "DistributeHeight" : "DistributeHeight", "OptimizeSliceVolume" : "OptimizeSliceVolume", "OptimizeHeightAndSliceVolume" : "OptimizeHeightAndSliceVolume"});

SPLM.Mfg.AM.Nester3D.Interlocking = Object.freeze({
    "AllowInterlocks" : "AllowInterlocks", "AvoidTunnels" : "AvoidTunnels", "AvoidAllInterlocks" : "AvoidAllInterlocks"});

SPLM.Mfg.AM.Nester3D.RotationAngleType = Object.freeze({
    "Degree90" : "Degree90", "Degree45" : "Degree45", "Degree30" : "Degree30", "Degree15" : "Degree15"});

export default SPLM;